/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Medical_RecordsInputs */

const en_claims_medical_records = /** @type {(inputs: Claims_Medical_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medical Records`)
};

const fr_claims_medical_records = /** @type {(inputs: Claims_Medical_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dossiers médicaux`)
};

/**
* | output |
* | --- |
* | "Medical Records" |
*
* @param {Claims_Medical_RecordsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_medical_records = /** @type {((inputs?: Claims_Medical_RecordsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Medical_RecordsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_medical_records(inputs)
	return fr_claims_medical_records(inputs)
});